<section id="register">
	<br/>
  <i class="fas fa-user-plus speaker-icon text-center"></i>
  <h2 class="section-heading">Registration</h2>
  <ul class="list-group text-center">
	  <li class="list-group-item">Deadline for registration: 31st May 2022</li>
	  <li class="list-group-item">Registration fee for Indian presenting author for one paper : INR 5,000/-</li>
	  <li class="list-group-item">Registration for foreign participants / authors for one paper : $300</li>
	  <li class="list-group-item">SCIE Journal publication: For the articles, which are considered for publication in SCIE journal, additional charges are applicable (₹3,000/- extra)</li>
	  <li class="list-group-item">For listeners and co-authors, who are not presenting any paper : INR 2000/-</li>
	  <li class="list-group-item">For listeners and co-authors, who are not presenting any paper from abroad : $100/-</li>

  </ul>
  <a class="register-btn hvr-buzz-out" href="https://forms.gle/2LVjCDcbtf7R1tBNA">Register Now</a>
</section>
<section id="payment">
	<br/>
  <i class="fas fa-rupee-sign speaker-icon text-center"></i>
  <h2 class="section-heading">Payment Procedure</h2>
  <ul class="list-group text-center">
	  <li class="list-group-item">Visit state bank icollect home: <a href="https://www.onlinesbi.com/sbicollect/icollecthome.htm">SBI iCollect</a></li>
	  <li class="list-group-item">Accept the terms and conditions and click on proceed</li>
	  <li class="list-group-item">Select the state as “Tamil Nadu” and Select type as “Educational Institutions”</li>
	  <li class="list-group-item">Select Educational Institutions as “Conference and Workshop NIT Trichy” and submit</li>
	  <li class="list-group-item">Select category as “ICAMAT 2022 MME” and provide details of payment and submit.</li>
	  <li class="list-group-item"></li>
	  <li class="list-group-item"><strong>Bank account details  for International participats</strong></li>
	  <li class="list-group-item">Name of the Account: Director, National Institute of Technology, Tiruchirappalli</li>
	  <li class="list-group-item">Account No: 10023883064</li>
	  <li class="list-group-item">SWIFT Code: SBININBB190</li>
	  <li class="list-group-item">Bank Name: State Bank of India</li>
	  <li class="list-group-item">Remitter information: Participant’s Name and contact number should be mentioned.</li>

  </ul>
</section>
<section id="submission">
	<br/>
  <i class="fas fa-stamp speaker-icon text-center"></i>
  <h2 class="section-heading">Submission / Workflow</h2>
  <ul class="list-group text-center">
	<li class="list-group-item">The deadline for registration is 31st May 2022</li>
	<li class="list-group-item">The deadline for submitting a full paper (to icamat2022@gmail.com) extended till 31st May 2022 </li>
	<li class="list-group-item">Full paper must be initally submitted to  icamat2022@gmail.com</li>
	<li class="list-group-item">Full paper to be submitted in Times New Roman font with 1.5 line spacing and the total number of words limited to 5000, Figures limited to 5, and Tables limited to 4. </li>
	<li class="list-group-item">At least one author for each paper MUST register for the conference by making a registration fee payment and filling out the given google form. </li>
	<li class="list-group-item">After initial scruitiny, the technical committee recommends submitting the paper to a specific journal along with the submission guidelines to the corresponding author by email. </li>
	<li class="list-group-item">Format the paper as per the specific journal guidelines and submit it to the respective website. </li>
	<li class="list-group-item">The review process may take 3-4 weeks. If accepted for publication in SCIE journal, additional fees must be paid. </li>


  </ul>
</section>
<style>
	section {
		padding-top: 86px;
		text-align: center;
	}
	i {
		display: block;
		margin: 0 auto;
		font-size: 2rem;
		padding-bottom: 1em;
	}
	h2 {
		text-align: center;
	}
</style>
